import { k8V2ContentfulMappings } from 'utils/productMaps'

/**
 * Adds display titles to a course tree based on internal title matches from k8V2ContentfulMappings
 * @param {Object} courseTree - The course tree object to process
 * @returns {Object} The processed course tree with display titles added where matches are found
 */
export function addDisplayTitlesToCourseTree(courseTree) {
  if (!courseTree || !courseTree.internalTitle) {
    return courseTree
  }

  const matchingMapping = k8V2ContentfulMappings.find(mapping => {
    const mappingDisplayTitle = mapping?.displayTitle?.toLowerCase()
    const courseTreeDisplayTitle = courseTree.internalTitle?.toLowerCase()
    return courseTreeDisplayTitle?.includes(mappingDisplayTitle)
  })

  if (matchingMapping) {
    return {
      ...courseTree,
      displayTitle: matchingMapping.displayTitle,
    }
  }

  console.log(
    `No matching display title found for course tree internal title: ${courseTree.internalTitle}`,
  )
  return courseTree
}

/**
 * Processes a collection of course trees by converting object to array and adding display titles
 * @param {Object} courseTreeCollection - Object containing course trees as values
 * @returns {Array} Array of processed course trees with display titles added where matches are found
 */
export function processCourseTreeCollectionv2ToWorkWithV1CourseShapes(
  courseTreeCollection,
) {
  if (!courseTreeCollection || typeof courseTreeCollection !== 'object') {
    return []
  }

  // Convert object values to array and process each course tree
  return Object.values(courseTreeCollection).map(courseTree =>
    addDisplayTitlesToCourseTree(courseTree),
  )
}
